import { Diamond } from "@src/types/DiamondDetail";

export type BulkQuantityEditorProps = {
  mItem?: Diamond;
  priceDetailsDataOptions?: any[];
  onBulkEditorChange?: any;
  viewOnly?: boolean;
};

export enum BulkQuantityField {
  Quantity = "quantity",
  TotalCarat = "total_carat",
  APPROX_EQUAL = "≈ ",
  Comment = "comment",
}

export const removeCt = (value: string): string => {
  if (!value) return "";
  return value.replace(/\s*ct$/i, "");
};
